import { getField } from "vuex-map-fields";

const serverSideErrorsArray = (state) => {
  if (!state.axiosError || state.axiosError.success) return [];
  const errors = state.axiosError?.response?.data?.error?.errors;
  if (!(errors)) return [];
  const axiosErrors = Object.entries(errors);
  if (!axiosErrors.length) return [];
  let allErrors = [];

  axiosErrors.forEach(([, errorArray]) => {
    allErrors = [...allErrors, ...errorArray];
  });

  return allErrors;
};
const errorsObject = (state) => state.axiosError?.response?.data?.error?.errors;
export default {
  serverSideErrorsArray,
  errorsObject,
  getField,
};
